// DevExtreme Global License & Localization Setup
// CRITICAL: This file must be imported BEFORE any DevExtreme component imports

// CRITICAL: Get license key - Vite embeds this at BUILD time
const licenseKey = import.meta.env.VITE_DEVEXTREME_LICENSE_KEY;

// Log license status for debugging
if (!licenseKey) {
  console.error('❌ DevExtreme license key not found!');
  console.error('⚠️ License must be set in .env.production BEFORE building');
  if (import.meta.env.DEV) {
    console.log('📝 Available environment variables:', 
      Object.keys(import.meta.env).filter(k => k.includes('DEVEXTREME'))
    );
  }
} else {
  console.log('✅ DevExtreme license key loaded');
}

// Method 1: Configure via GlobalConfig object (recommended by DevExtreme docs)
// This must happen BEFORE any DevExtreme component is imported
if (typeof window !== 'undefined' && licenseKey) {
  (window as any).DevExpress = (window as any).DevExpress || {};
  (window as any).DevExpress.config = {
    licenseKey: licenseKey,
    defaultCurrency: 'EUR'
  };
  console.log('✅ DevExtreme license configured via GlobalConfig');
}

// Method 2: Synchronous configuration via config() - runs immediately
import config from 'devextreme/core/config';
import { locale, loadMessages } from 'devextreme/localization';

if (licenseKey) {
  config({ 
    licenseKey,
    defaultCurrency: 'EUR'
  });
  console.log('✅ DevExtreme configured via config() method');
}

// Set up Slovenian localization - synchronous import
try {
  // Import the official Slovenian dictionary
  const slovenianMessages = await import('devextreme/localization/messages/sl.json');
  
  // Load the official Slovenian messages
  loadMessages(slovenianMessages.default || slovenianMessages);
  
  // Set Slovenian locale for proper decimal/thousands separators
  // sl-SI format: 1.234,56 (thousands: dot, decimal: comma)
  locale('sl-SI');
  
  console.log('✅ Slovenian localization configured');
} catch (localeError) {
  console.warn('⚠️ Could not load Slovenian localization:', localeError);
  // Fallback to default locale
  try {
    locale('sl'); // Try without -SI suffix
  } catch (e) {
    console.error('❌ Failed to set fallback locale:', e);
  }
}

export { licenseKey };
